import { DevModeSettings } from './dev-mode-settings';
import { Injectable } from '@angular/core';
import { EnvConfigService } from '@openmfp/portal-ui-lib';

export const DXP_DEV_MODE_SETTINGS_KEY = 'dxp-dev-mode-settings';

@Injectable({ providedIn: 'root' })
export class DevModeCdmSettingsService {
  constructor(private envConfigService: EnvConfigService) {}

  async getDevModeSettings(): Promise<DevModeSettings> {
    const { developmentInstance } = await this.envConfigService.getEnvConfig();

    let resultingDevModeSettings = {
      isActive: developmentInstance, // in dev mode always look for external configuration
      cdm: [],
      serviceProviderConfig: {},
    };

    let devModeSettingsString = '';
    try {
      devModeSettingsString =
        window.localStorage.getItem(DXP_DEV_MODE_SETTINGS_KEY) ?? '';
    } catch (_e) {
      // ignore local storage exceptions
    }

    if (devModeSettingsString) {
      try {
        resultingDevModeSettings = {
          // you can enable external configuration in production by setting isActive:true
          ...resultingDevModeSettings,
          ...JSON.parse(devModeSettingsString),
        };
      } catch (e) {
        console.error(
          `Failed to parse the dev mode settings in your localstorage because of ${e}`,
        );
      }
    }

    if (!resultingDevModeSettings.isActive) {
      return {
        configs: [],
        serviceProviderConfig: {},
      };
    }

    return {
      configs: resultingDevModeSettings.cdm,
      serviceProviderConfig: resultingDevModeSettings.serviceProviderConfig,
    };
  }
}
